import { useWindowDimensions } from 'react-native'

export const useThreeCardSize = () => {
  const { height } = useWindowDimensions()
  if (height <= 700) {
    return 'small'
  }
  if (height <= 800) {
    return 'medium'
  }
  return 'big'
}
